import React, { useState } from "react";
import { Button, Typography } from "antd";
import { getActiveOrganizationId } from "../utils/organizationId";
import CreateOrganizationModal from "./CreateOrganizationModal";

const { Title, Paragraph } = Typography;

export default function NoOrganizationGate({ children }) {
  const [createOpen, setCreateOpen] = useState(false);
  const hasOrganization = Boolean(getActiveOrganizationId());

  if (hasOrganization) {
    return children;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 64px)",
          padding: "2rem",
        }}
      >
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <Title level={4}>You are not in an organization yet</Title>
          <Paragraph type="secondary">
            Create a new organization to start using Mailinflow, or accept an
            invite from your team if you have one.
          </Paragraph>
          <Button type="primary" onClick={() => setCreateOpen(true)}>
            Create organization
          </Button>
        </div>
      </div>
      <CreateOrganizationModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
      />
    </>
  );
}
